import clsx from 'clsx';
import queryString from 'query-string';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Utils
import useRouterQuery from '@/utils/hooks/utils/useRouterQuery';

// Libs
import { PERMISSIONS } from '@/lib/permissions/socialPermissions';
import { OAUTH_NETWORKS } from '@/lib/routes/privateRoutes';

// Components
import Button from '@/components/base/Button';
import Icon from '@/components/base/Icon';
import Tooltip from '@/components/base/Tooltip';

export function ButtonUnlockInstagramPermission() {
    const { t } = useTranslation('scheduler');
    const { deleteAllQueries } = useRouterQuery();
    const redirectUrl = deleteAllQueries();

    return (
        <Tooltip content={t('unlock_auto_posting')}>
            <Button
                as="a"
                data-testid="button-unlock-auto-posting-instagram"
                className="w-12 !min-w-min !px-0"
                variant={'whiteNoBorder'}
                href={`${OAUTH_NETWORKS.facebook}?${queryString.stringify(
                    {
                        redirect_to: encodeURIComponent(redirectUrl),
                        permissions: [PERMISSIONS.SCHEDULER]
                    },
                    { arrayFormat: 'bracket' }
                )}`}>
                <Icon icon="autopost-no" />
            </Button>
        </Tooltip>
    );
}
